import React, { useState } from 'react';
import toast from 'react-hot-toast';
import './StaticPages.css';

export default function Contact() {
  const [form, setForm] = useState({ name: '', phone: '', email: '', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success('Message sent! We will contact you within 24 hours.');
    setForm({ name: '', phone: '', email: '', message: '' });
  };

  return (
    <div className="static-page">
      <div className="page-header">
        <h1>Contact Us</h1>
        <p>We're here to help you find your perfect match</p>
      </div>

      <div className="container static-content">
        <div className="contact-grid">
          {/* Info */}
          <div className="contact-info">
            <h2>Get In Touch</h2>
            <p>Have questions? We're happy to help. Reach out to us anytime.</p>
            <div className="contact-items">
              <div className="contact-item">
                <div className="ci-icon">📞</div>
                <div>
                  <strong>Phone</strong>
                  <a href="tel:+91 9842724724">+91 9842724724</a>
                </div>
              </div>
              <div className="contact-item">
                <div className="ci-icon">✉️</div>
                <div>
                  <strong>Email</strong>
                  <a href="mailto:support@suvaranmaranmatrimony.msdiscoveriescom">support@suvaranmaranmatrimony.msdiscoveriescom</a>
                </div>
              </div>
              <div className="contact-item">
                <div className="ci-icon">🕐</div>
                <div>
                  <strong>Working Hours</strong>
                  <span>Mon – Sat: 9:00 AM – 7:00 PM</span>
                </div>
              </div>
            </div>

            <div className="contact-note">
              <h3>📋 Payment & Profile Help</h3>
              <p>For payment verification or profile issues, please contact us with your registered phone number and UPI Transaction ID.</p>
            </div>
          </div>

          {/* Form */}
          <div className="contact-form-wrap card" style={{padding:'32px'}}>
            <h2>Send a Message</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Your Name</label>
                <input className="form-input" value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Enter your name" required />
              </div>
              <div className="form-group">
                <label className="form-label">Phone Number</label>
                <input className="form-input" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} placeholder="10-digit phone number" maxLength={10} required />
              </div>
              <div className="form-group">
                <label className="form-label">Email (Optional)</label>
                <input className="form-input" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="your@email.com" />
              </div>
              <div className="form-group">
                <label className="form-label">Message</label>
                <textarea className="form-textarea" value={form.message} onChange={e => setForm({...form, message: e.target.value})} placeholder="How can we help you?" required />
              </div>
              <button type="submit" className="btn btn-gold" style={{width:'100%'}}>Send Message</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
